import { useEffect, useState } from 'react';
import { CalendarDays } from 'lucide-react';

const DATE = new Intl.DateTimeFormat('th-TH', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });

function format(date: Date) {
  const time = `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
  return { time, label: DATE.format(date) };
}

/** Today's date — the reference date every forecast, "late" flag and today-line is computed against (server side). */
export function ClockChip() {
  const [now, setNow] = useState(() => format(new Date()));

  useEffect(() => {
    const id = setInterval(() => setNow(format(new Date())), 15_000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="hidden items-center gap-2 rounded-xl border border-border bg-surface-sunken px-3 py-1.5 sm:flex">
      <CalendarDays size={16} className="text-primary" />
      <div className="leading-tight">
        <p className="num text-sm font-bold text-text-primary">{now.time}</p>
        <p className="text-[10.5px] text-text-secondary">{now.label}</p>
      </div>
    </div>
  );
}
